import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import ProductLine from '@afosto/app-components-react/ProductLine';
import QuantityBox from '@afosto/app-components-react/QuantityBox';
import translations from './translations';

const PutawayListItem = ({ disabled, item, onClick, SelectionComponent }) => {
  const intl = useIntl();

  return (
    <Grid item xs={12}>
      <Card>
        <Box display="flex" flexWrap="nowrap" alignItems="center">
          {SelectionComponent && <SelectionComponent />}
          <Box display="flex" flexGrow={1} alignItems="center">
            <CardActionArea disabled={disabled} onClick={onClick}>
              <Box display="flex">
                <Box flex={1} p={1} pt={2}>
                  <ProductLine item={item} />
                </Box>
                <Hidden smDown implementation="js">
                  <Box p={1}>
                    <QuantityBox
                      label={intl.formatMessage(translations.properties.place)}
                      quantity={item.quantity}
                    />
                  </Box>
                </Hidden>
              </Box>
            </CardActionArea>
          </Box>
        </Box>
      </Card>
    </Grid>
  );
};

PutawayListItem.propTypes = {
  disabled: PropTypes.bool,
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  SelectionComponent: PropTypes.elementType,
};

PutawayListItem.defaultProps = {
  disabled: true,
  onClick: undefined,
  SelectionComponent: undefined,
};

export default PutawayListItem;
